class CollectionHero extends HTMLElement {
  connectedCallback() {
    this.showButton = this.querySelector('[data-action="show"]');
    this.content = this.querySelector('[data-target="content"]');
    this.hideButton = this.content?.querySelector('[data-action="hide"]');

    if (!this.showButton || !this.content || !this.hideButton) return;

    this.showButton.addEventListener('click', () => this.open());
    this.hideButton.addEventListener('click', () => this.close());
  }

  open() {
    if (this.content.classList.contains('open')) return;

    this.removeTransitionListener();

    this.content.classList.add('open');
    this.content.style.height = '0px';
    this.content.style.opacity = '0';
    this.content.style.overflow = 'hidden';

    this.transitionEndHandler = (e) => {
      if (e.target !== this.content) return;

      this.removeTransitionListener();
      this.content.style.overflow = 'visible';
    };

    this.content.addEventListener('transitionend', this.transitionEndHandler);

    window.requestAnimationFrame(() => {
      this.content.style.height = `${this.content.scrollHeight}px`;
      this.content.style.opacity = '1';
    });

    this.showButton.hidden = true;
  }

  close() {
    if (!this.content.classList.contains('open')) return;

    this.removeTransitionListener();

    // Set current height explicitly before collapsing
    const currentHeight = this.content.scrollHeight;
    this.content.style.height = `${currentHeight}px`;
    this.content.style.overflow = 'hidden';

    // Force reflow to ensure the transition is triggered
    void this.content.offsetHeight;

    this.transitionEndHandler = (e) => {
      if (e.target !== this.content) return;

      this.removeTransitionListener();
      this.content.classList.remove('open');
      this.content.style.height = null;
      this.content.style.opacity = null;
      this.content.style.overflow = null;

      // Optional: Scroll into view after collapsing
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    this.content.addEventListener('transitionend', this.transitionEndHandler);

    // Set final styles to animate to
    this.content.style.height = '0px';
    this.content.style.opacity = '0';

    this.showButton.hidden = false;
  }

  removeTransitionListener() {
    if (this.transitionEndHandler) {
      this.content.removeEventListener('transitionend', this.transitionEndHandler);
      this.transitionEndHandler = null;
    }
  }
}

if (!customElements.get("collection-hero")) {
  customElements.define("collection-hero", CollectionHero);
}
